export const excludedUrls : string[] = [
 'estudiantes/estudiante/info',
 'labs-equivalencia-estudiante/',
 'tipo-horario-preferencia/estudiante/',
 'solicitar-horario/accion/rechazar',
 'teams-meeting-process/eventos-meeting',
 'horarios/cambio-meeting-actualizacion-horarios',
 'clientify-publico/origen-contacto',
  'persona-publico/documento'
];
